import React, { useState } from "react";

const Tabs = ({tabsList, selectedIndex, interactive, onTabSelected }) => {
  const [activeTab, setActiveTab] = useState(selectedIndex);

  const handleTabClick = (index, tabName) => {
    setActiveTab(index);
    if (onTabSelected) {
      onTabSelected(tabName);
    }
  };

  return (
    <div className="w-full">
      <ul className="flex">
        {tabsList.map((tab, index) => (
          <li key={index} className="mr-2">
            <button
              className={`inline-block py-2 px-4 font-medium ${
                activeTab === index
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : interactive ? "text-gray-500 hover:text-gray-700" : "text-gray-500 cursor-default" 
              }`}
              onClick={interactive ? () => handleTabClick(index, tab.pageName): undefined}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>
      {/* <div className="mt-4">
        {tabs[activeTab].content}
      </div> */}
    </div>
  );
};

export default Tabs;
